import styled from 'styled-components';
import { PageFullWidth } from 'Ui';
import { Linkedin } from 'Ui/Icons/icons';
import icoFacebook from 'Assets/images/icoFacebook.svg';
import icoInstagram from 'Assets/images/icoInstagram.svg';
import inspi1 from 'Assets/images/inspi1.jpg';
import inspi2 from 'Assets/images/inspi2.jpg';
import inspi3 from 'Assets/images/inspi3.jpg';
import inspi4 from 'Assets/images/inspi4.jpg';

const InspirationsContainer = styled.section`
  background-color: #fff;
  overflow: hidden;
`;

const InspirationsInner = styled.div`
  max-width: 184rem;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 2rem;
  padding: 6rem 0;

  @media screen and (max-width: 48rem) {
    flex-direction: column;
  }
`;

const PhotoGroup = styled.div`
  display: flex;
  gap: 1.6rem;
  width: 100%;
  min-width: 0;
  justify-content: space-around;

  @media screen and (max-width: 48rem) {
    gap: 1.2rem;
  }
`;

const Photo = styled.div`
  position: relative;
  flex: 1 1 0;
  min-width: 0;
  width: 100%;
  max-width: 18rem;
  aspect-ratio: 3 / 4;
  overflow: hidden;

  img {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media screen and (max-width: 48rem) {
    max-width: 16rem;
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  flex: 0 0 auto;
  max-width: 46rem;
  padding: 0 2rem;

  @media screen and (max-width: 48rem) {
    order: -1;
    margin-bottom: 2rem;
  }
`;

const Title = styled.h2`
  font-family: var(--font-secondary) !important;
  font-weight: 400;
  font-size: 4.4rem;
  line-height: 44px;
  letter-spacing: 0px;
  color: #000;
  margin: 0 0 2rem;

  em {
    font-family: var(--font-tertiary) !important;
    font-style: normal;
  }
`;

const Text = styled.p`
  font-family: var(--font-primary);
  font-weight: 400;
  font-size: 1.4rem;
  line-height: 100%;
  letter-spacing: 0px;
  color: #000;
  margin: 0 0 1.6rem;
`;

const Handle = styled.span`
  font-family: var(--font-primary);
  font-weight: 600;
  font-size: 1.6rem;
  text-transform: uppercase;
  color: #000;
  margin-bottom: 3rem;
  line-height: 100%;
  letter-spacing: 0px;
  vertical-align: middle;
`;

const FollowButton = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: #000;
  color: #fff !important;
  font-family: var(--font-primary);
  font-weight: 500;
  font-size: 1.1rem;
  letter-spacing: 0.2px;
  line-height: 100%;
  text-transform: uppercase;
  text-decoration: none;
  padding: 1.4rem 3rem;
  margin-bottom: 2rem;
`;

const SocialLinks = styled.div`
  display: flex;
  align-items: center;
  gap: 1.6rem;

  a {
    display: flex;
    align-items: center;
    color: #000;
    /* Icônes en gris par défaut ; pas de couleur de marque au survol,
       on se contente d'assombrir légèrement. */
    opacity: 0.4;
    transition: opacity 0.2s ease;
  }

  a:hover {
    opacity: 0.65;
  }

  img {
    display: block;
    width: 2.2rem;
    height: 2.2rem;
  }

  svg {
    width: 2.2rem;
    height: 2.2rem;
  }

  svg path {
    fill: #000;
  }
`;

type Props = {
  titleStart: string;
  titleEmphasis: string;
  titleEnd: string;
  text: string;
  handle: string;
  buttonLabel: string;
};

export const Inspirations = ({
  titleStart,
  titleEmphasis,
  titleEnd,
  text,
  handle,
  buttonLabel,
}: Props) => (
  <InspirationsContainer>
    <PageFullWidth>
      <InspirationsInner>
      <PhotoGroup>
        <Photo>
          <img src={inspi1} alt="" aria-hidden="true" loading="lazy" />
        </Photo>
        <Photo>
          <img src={inspi2} alt="" aria-hidden="true" loading="lazy" />
        </Photo>
      </PhotoGroup>
      <Content>
        <Title>
          {titleStart} <em>{titleEmphasis}</em>
          <br />
          {titleEnd}
        </Title>
        <Text>{text}</Text>
        <Handle>{handle}</Handle>
        <FollowButton
          href="https://www.instagram.com/bazarchic/"
          target="_blank"
          rel="noopener noreferrer"
        >
          {buttonLabel}
        </FollowButton>
        <SocialLinks>
          <a
            href="https://www.facebook.com/BazarChicFR"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook"
          >
            <img src={icoFacebook} alt="" aria-hidden="true" />
          </a>
          <a
            href="https://www.instagram.com/bazarchic/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
          >
            <img src={icoInstagram} alt="" aria-hidden="true" />
          </a>
          <a
            href="https://www.linkedin.com/company/bazarchic/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn"
          >
            <Linkedin />
          </a>
        </SocialLinks>
      </Content>
      <PhotoGroup>
        <Photo>
          <img src={inspi3} alt="" aria-hidden="true" loading="lazy" />
        </Photo>
        <Photo>
          <img src={inspi4} alt="" aria-hidden="true" loading="lazy" />
        </Photo>
      </PhotoGroup>
      </InspirationsInner>
    </PageFullWidth>
  </InspirationsContainer>
);

export default Inspirations;
